import React from "react";

import { TeaserHeadingType } from "types";

export const getTeaserTitle = (
  title: string,
  headingType?: TeaserHeadingType,
  classNames?: string[]
) => {
  switch (headingType) {
    case TeaserHeadingType.h3:
      return (
        <h3 className={classNames?.join("")}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </h3>
      );
    case TeaserHeadingType.h4:
      return (
        <h4 className={classNames?.join("")}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </h4>
      );
    default:
      return (
        <h2 className={classNames?.join("")}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </h2>
      );
  }
};
